/**
 * Review r17 segurança (B1): "link de volta" para um registro (card de Tarefas, canal de registro do Equipe) só pode ser
 * rota INTERNA do MalgoOS. A regex antiga (`^\/[^/\\]`) olhava só o segundo caractere: `/\t/evil.example` passava e o
 * navegador, que tira TAB e quebra de linha ao montar a URL, abria `//evil.example` (outro site). A conferência agora é
 * pela URL já montada: começa com uma barra só, nenhum caractere de controle, espaço ou barra invertida em todo o texto, e
 * a URL resolvida contra uma origem fictícia fica nessa origem com o caminho começando por uma barra só. Vale na API
 * (zod das rotas) e no navegador (antes de montar o `<Link>`, para o que já estiver gravado).
 */

const ORIGEM_FICTICIA = 'https://x.invalid';
// Controle C0, espaço, DEL, controle C1, separadores de linha/parágrafo e barra invertida.
// eslint-disable-next-line no-control-regex
const PROIBIDOS = new RegExp('[\\u0000-\\u0020\\u007f-\\u009f\\u2028\\u2029\\\\]');

export function ehRotaInterna(link: string): boolean {
  if (typeof link !== 'string' || link.length < 2 || link[0] !== '/' || link[1] === '/') return false;
  if (PROIBIDOS.test(link)) return false;
  let u: URL;
  try {
    u = new URL(link, ORIGEM_FICTICIA);
  } catch {
    return false;
  }
  return u.origin === ORIGEM_FICTICIA && u.pathname.startsWith('/') && !u.pathname.startsWith('//');
}
